import {CHANGE_PRIMARY_COLOR, CHANGE_THEME} from "./types";

export const changePrimaryColor = primaryColor => {
    localStorage.setItem("primaryColor", primaryColor);

    window.less
        .modifyVars({
            "@primary-color": primaryColor
        })
        .then(() => {
            //do other stuff here
        })
        .catch(error => {
            console.error(error);
        });

    return {
        type: CHANGE_PRIMARY_COLOR,
        payload: primaryColor
    }
};

export const changeTheme = theme => {
    localStorage.setItem("theme", theme);

    return {
        type: CHANGE_THEME,
        payload: theme
    }
};